// extracted by mini-css-extract-plugin
export default {"card-separator":"styles_card-separator__btl9K"};